import CONFIG from '$config'
import {EXTERNAL_ROUTES} from '$constants/external-routes'

/**
 * @description 통합조회 최상위 에러
 */
export class CommonError extends Error {
    name = 'CommonError'

    readonly errorTypeName: string = 'CommonError'
}

/**
 * @description API 호출했을 때 발생하는 에러 중 최상위 에러
 */
export class ApiError extends CommonError {
    requestURLObject: URL

    constructor(requestURL: string) {
        super()
        this.requestURLObject = new URL(requestURL)
    }

    name = 'ApiError'

    /**
     * @description 사용자에게 확인받아야 하는 경우 빈 문자열이 아닌 값을 반환
     */
    readonly confirmMessage: string = ''

    /**
     * @description 빈 문자열이 아니면 해당 주소로 이동 (모바일)
     */
    readonly redirectHref: string = ''

    /**
     * @description 빈 문자열이 아니면 해당 주소로 이동 (pc)
     */
    pcRedirectHref = ''

    /**
     * @description 이동할 때 replace로 할지 push로 할지 결정
     */
    readonly needReplace: boolean = false
}

/**
 * @description HTTP Status 403 에러
 */
export class ForbiddenError extends ApiError {
    constructor(
        requestURL: string,
        public isLoginFailed: boolean,
    ) {
        super(requestURL)
    }

    readonly name = 'ForbiddenError'

    readonly redirectHref = `${CONFIG.URL.NID}${EXTERNAL_ROUTES.NID.LOGIN}?url=${encodeURIComponent(
        this.requestURLObject.href,
    )}`

    readonly needReplace: boolean = true
}

/**
 * @description 흐름은 중단하지만 무시할 에러
 */
export class ShouldBeIgnoreError extends CommonError {
    readonly name = 'ShouldBeIgnoreError'
}
